import OktaAuth, { toRelativeUrl } from '@okta/okta-auth-js';
import { QueryClientProvider } from '@tanstack/react-query';
import { LoginCallback, Security } from '@okta/okta-react';
import { Route, Routes, useNavigate } from 'react-router';
import { Stages } from '@/pages/stages';
import { Toaster } from '@repo/ui/components/ui/sonner';
import { oktaAuth } from '@/auth';
import { Dashboard } from '@/pages/dashboard';
import { DefaultLayout } from '@/components/layout';
import { DashboardLayout } from '@/components/layout/dashboard';
import { ResponsiveCandidateWrapper } from '@/components/candidates/container';
import { PhotoVogueLayout } from '@/components/layout/photovogue';
import { ModerationQueue } from '@/pages/photovogue/moderation';
import { PhotographerList } from '@/pages/photovogue/photographers';
import { PhotographerDetail } from '@/pages/photovogue/photographer-detail';
import { PicOfTheDay } from '@/pages/photovogue/pic-of-the-day';
import { QueryStateManagement, UserProvider } from '@/state';

export type RouteParams = {
  stageId?: string;
  openCallId?: string;
  candidateId?: string;
};

export const App = () => {
  const navigate = useNavigate();
  const restoreOriginalUri = async (
    _oktaAuth: OktaAuth,
    originalUri: string,
  ) => {
    navigate(toRelativeUrl(originalUri, window.location.origin));
  };
  return (
    <QueryClientProvider client={QueryStateManagement.client}>
      <UserProvider>
        <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
          <Routes>
            <Route path="/auth/callback" element={<LoginCallback />} />

            <Route path="/" element={<DashboardLayout />}>
              <Route index element={<Dashboard />} />
            </Route>

            <Route path="/open-calls/:openCallId" element={<DefaultLayout />}>
              <Route path="stage/:stageId" element={<Stages />}>
                <Route
                  path="candidate/:candidateId"
                  element={<ResponsiveCandidateWrapper />}
                />
              </Route>
            </Route>

            <Route path="/photovogue" element={<PhotoVogueLayout />}>
              <Route index element={<ModerationQueue />} />
              <Route path="pic-of-the-day" element={<PicOfTheDay />} />
              <Route
                path="admin/photographers"
                element={<PhotographerList />}
              />
              <Route
                path="admin/photographers/:photographerId"
                element={<PhotographerDetail />}
              />
            </Route>
          </Routes>
          <Toaster />
        </Security>
      </UserProvider>
    </QueryClientProvider>
  );
};
